import styled from 'styled-components/macro'

import { Card, Layout, Text } from '@loadsmart/loadsmart-ui'

import { formatDescription, formatZip } from 'core/presenters/stopPresenter'
import { LaneInformation } from 'core/ui/components/stop/LaneInformation'

import { type ConfirmAwardedLaneAction } from '../domain/ConfirmAwardedLaneAction'
import { type Currency } from '../domain/Currency'
import { type DistanceUnit } from '../domain/DistanceUnit'
import { type Lane } from '../domain/Lane'
import { getFormattedCurrency } from '../presenters/lanePresenter'
import { formatRates } from '../presenters/rfpAwardedPresenter'
import { AwardConfirmationActions } from './AwardConfirmationActions'
import { AwardedLaneItemAccordion } from './AwardedLaneItemAccordion'

const StyledCard = styled(Card)`
  width: 100%;
`

export type AwardedProposalItemProps = {
  rfpId: string
  position: number
  awardedLane: Lane
  isConfirming?: boolean
  isDisabled?: boolean
  isAwardFinished?: boolean
  handleConfirmLane?: (laneId: number, action: ConfirmAwardedLaneAction) => void
  distanceUnit: DistanceUnit
  currency: Currency
}

export function AwardedLaneItem({
  rfpId,
  position,
  awardedLane,
  isAwardFinished,
  isConfirming,
  isDisabled,
  handleConfirmLane,
  distanceUnit,
  currency,
}: AwardedProposalItemProps) {
  const { distance } = awardedLane

  const stops = awardedLane.stops
  const formattedCurrency = getFormattedCurrency(currency)
  const { flatRate, perDistanceRate } = formatRates(awardedLane, distanceUnit, formattedCurrency)

  return (
    <StyledCard>
      <Card.Body>
        <Layout.Stack justify="center">
          <Layout.Group justify="space-between">
            <LaneInformation
              stops={stops}
              distance={distance}
              valueFormatter={formatDescription}
              extraFormatter={formatZip}
              distanceUnit={distanceUnit}
            />
            <Layout.Group align="center">
              <Layout.Group align="center">
                <Text variant="heading-md-bold">{flatRate}</Text>
                <Text variant="caption">{perDistanceRate}</Text>
              </Layout.Group>
              <AwardConfirmationActions
                awardedLane={awardedLane}
                isAwardFinished={isAwardFinished}
                isConfirming={isConfirming}
                isDisabled={isDisabled}
                handleConfirmLane={handleConfirmLane}
              />
            </Layout.Group>
          </Layout.Group>
          <AwardedLaneItemAccordion rfpId={rfpId} position={position} awardedLane={awardedLane} />
        </Layout.Stack>
      </Card.Body>
    </StyledCard>
  )
}
